import React from 'react';
import { StatsigProvider as StatsigProviderComponent } from '@statsig/react-bindings';
import { getPageEnvByHost } from '@/utils/environment';


export const StatsigProviderV2: React.FC<{ merchantId?: string }> = ({ merchantId, children }) => {
  const user = {
    userID: merchantId,
  };
  return (
    <StatsigProviderComponent
      sdkKey="client-LJmokBKXH96F2ZdI0ZYDyd27hX7Z8HfNU35XJvv3jxa"
      user={user || {}}
      options={{ environment: { tier: getPageEnvByHost() === 'prod' ? 'production' : 'staging' } }}
      loadingComponent={<div></div>}
    >
      {children}
    </StatsigProviderComponent>
  );
};

export default StatsigProviderV2;
